import { Pipe, PipeTransform } from '@angular/core';
import { GfTranslateService } from '../../../../core/services/core.translate.service';
import * as _ from 'lodash';

@Pipe({
    name: 'statusText'
})
export class StatusTextFilter implements PipeTransform {
    constructor(private translateService: GfTranslateService) {};

    transform(ti: any): string {
        const defaultValue = ti.statusId ? 
            this.translateService.translate('Open') : 
            this.translateService.translate('Closed');

        return _.get(ti, 'extraFields.status.fieldData.elementName', defaultValue);
    };
};